import { render, staticRenderFns } from "./Editer.vue?vue&type=template&id=72309056&scoped=true&"
import script from "./Editer.vue?vue&type=script&lang=js&"
export * from "./Editer.vue?vue&type=script&lang=js&"
import style0 from "./Editer.vue?vue&type=style&index=0&id=72309056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72309056",
  null
  
)

export default component.exports